import Splide from "@splidejs/splide";

const init = () => {
    const splideCheck = document.getElementById("splide-review");
    if (splideCheck) {
        new Splide(".splide", {
            perPage: 1,
            mediaQuery: "min",
            breakpoints: {
                1281: {
                    perPage: 2,
                },
            },
        }).mount();
    }
};

init();
